<script setup>
import { APP } from "@/config/app";
const props = defineProps({
  inline: {
    type: [Boolean],
    required: false,
    default: false,
  }
})
</script>
<template>
  <template v-if="APP.MyWealthMode && props.inline">
    <slot />
  </template>
  <div v-else-if="APP.MyWealthMode">
    <slot />
  </div>
</template>

